var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherOptionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2985",
    "data-name": "Rectangle 2985",
    width: 24,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27656",
    "data-name": "Group 27656",
    transform: "translate(-67.4 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27656-2",
    "data-name": "Group 27656",
    transform: "translate(67.4 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27656-3",
    "data-name": "Group 27656",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37890",
    "data-name": "Path 37890",
    d: "M20.3,19.4a.9.9,0,1,1-.9-.9.9.9,0,0,1,.9.9",
    transform: "translate(-7.4 -7.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37891",
    "data-name": "Path 37891",
    d: "M18.8,20.6a1.8,1.8,0,1,1,1.8-1.8,1.8,1.8,0,0,1-1.8,1.8m0-1.8h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Z",
    transform: "translate(-6.8 -6.8)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37892",
    "data-name": "Path 37892",
    d: "M30.8,19.4a.9.9,0,1,1-.9-.9.9.9,0,0,1,.9.9",
    transform: "translate(-11.6 -7.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37893",
    "data-name": "Path 37893",
    d: "M29.3,20.6a1.8,1.8,0,1,1,1.8-1.8,1.8,1.8,0,0,1-1.8,1.8m0-1.8h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Z",
    transform: "translate(-11 -6.8)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37894",
    "data-name": "Path 37894",
    d: "M9.8,19.4a.9.9,0,1,1-.9-.9.9.9,0,0,1,.9.9",
    transform: "translate(-3.2 -7.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37895",
    "data-name": "Path 37895",
    d: "M8.3,20.6a1.8,1.8,0,1,1,1.8-1.8,1.8,1.8,0,0,1-1.8,1.8m0-1.8h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Z",
    transform: "translate(-2.6 -6.8)",
    fill: "#fc3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherOptionIcon);
export default __webpack_public_path__ + "static/media/other-option-icon.6a3dc1c980922e1d8994e2370601ded0.svg";
export { ForwardRef as ReactComponent };